import { groupBy } from 'lodash';
import { IAmendment, IRegulation } from '../../contracts/amendment.contract';

// This function merges amendement with similar description, mandatory/guide, operational/hardware, compliance-date-type, ship-age-date, app-to-age, and compliance-date
const mergeRegulationDescriptionETC = (filteredRegulation: IRegulation) => {
    return groupBy(filteredRegulation?.Amendments, (amendment: IAmendment) => {
        const normalizedDescription =
            amendment.Description.replace(/[^a-zA-Z0-9\s]/g, '') // Remove special characters
                .toLowerCase()
                .trim()
                .split(/\s+/)
                .join(' ') +
            amendment.MandatoryOrGuide +
            amendment.OperationalOrHardware +
            amendment.AppToAge +
            amendment.ComplianceDate;

        return normalizedDescription;
    });
};

export default mergeRegulationDescriptionETC;
